document.addEventListener("DOMContentLoaded", function () {
  const ratingBarWidget = document.querySelector(
    "reviewsio-rating-bar"
  );

  const reviewList = document.querySelector(
    "reviewsio-product-reviews-widget"
  );

  if (ratingBarWidget && reviewList) {
    ratingBarWidget.addEventListener("click", () => {
      const yOffset = -120;
      const y = reviewList.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  }


  let showMoreButton = document.querySelector(
    ".custom-product-description .show-more-button"
  );
  let descriptionPreview = document.querySelector(
    ".custom-product-description .description-preview"
  );
  let descriptionFull = document.querySelector(
    ".custom-product-description .description-full"
  );

  if (showMoreButton && descriptionPreview && descriptionFull) {
    showMoreButton.addEventListener("click", function () {
      descriptionPreview.classList.toggle("hidden");
      descriptionFull.classList.toggle("hidden");
      if (descriptionFull.classList.contains("hidden")) {
        showMoreButton.textContent = "Show more";
      } else {
        showMoreButton.textContent = "Hide";
      }
    });
  }
});
